'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectionsRemove = exports.connectionsSet = exports.measurementsRemove = exports.measurementsSet = undefined;

var _connectionsConstants = require('./connectionsConstants');

var measurementsSet = exports.measurementsSet = function measurementsSet(_ref) {
  var id = _ref.id,
      measurements = _ref.measurements;
  return { type: _connectionsConstants.MEASUREMENT_SET, id: id, measurements: measurements };
}; // Constants
var measurementsRemove = exports.measurementsRemove = function measurementsRemove(_ref2) {
  var id = _ref2.id,
      measurements = _ref2.measurements;
  return { type: _connectionsConstants.MEASUREMENT_REMOVE, id: id, measurements: measurements };
};

var connectionsSet = exports.connectionsSet = function connectionsSet(_ref3) {
  var id = _ref3.id,
      connections = _ref3.connections;
  return { type: _connectionsConstants.CONNECTIONS_SET, id: id, connections: connections };
};
var connectionsRemove = exports.connectionsRemove = function connectionsRemove(_ref4) {
  var id = _ref4.id,
      connections = _ref4.connections;
  return { type: _connectionsConstants.CONNECTIONS_REMOVE, id: id, connections: connections };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/connectionsActions.js
// module id = 1709
// module chunks = 0